import { IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from './key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';
import { IViolation, office365AuthTypes, shellStringResources, Credential, IAttribute, servicePrincipalCredentialTypes } from 'shell-models-lib';

@Metamodel.model({
    name: adfModelTypeMap.office365.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Office365_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Office365_DisplayText)
    ]
})
export class Office365LinkedService extends LinkedService {

    public static readonly MODEL: IModel;
    public static readonly SERVICE_PRINCIPAL_ID: IAttribute;
    public static readonly SERVICE_PRINCIPAL_KEY: IAttribute;
    public static readonly SERVICE_PRINCIPAL_EMBEDDED_CERT: IAttribute;
    public static readonly SERVICE_PRINCIPAL_EMBEDDED_CERT_PASSWORD: IAttribute;
    public static readonly TENANT: IAttribute;

    public office365SubscriptionId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Office365Tenant
    })
    public office365TenantId?: string;

    public userGroups: string[] = [];

    public servicePrincipalTenantId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalID,
        association: 'SERVICE_PRINCIPAL_ID',
        accepts: ['String']
    })
    public servicePrincipalId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalKey,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'SERVICE_PRINCIPAL_KEY',
        accepts: ['String']
    })
    public servicePrincipalKey?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalCredentialType
    })
    public servicePrincipalCredentialType? = servicePrincipalCredentialTypes.ServicePrincipalCert;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalEmbeddedCert,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'SERVICE_PRINCIPAL_EMBEDDED_CERT',
        templatable: true,
        accepts: ['String']
    })
    public servicePrincipalEmbeddedCert?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalEmbeddedCertPassword,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'SERVICE_PRINCIPAL_EMBEDDED_CERT_PASSWORD',
        templatable: true,
        accepts: ['String']
    })
    public servicePrincipalEmbeddedCertPassword?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType?: string;

    @Metamodel.attribute({
        display: shellStringResources.Credential,
        reference: true,
        constraint: {
            validator: Office365LinkedService.validateCredential
        }
    })
    public credential?: Credential;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    private static validateCredential(linkedservice: Office365LinkedService, referencedCredential: Credential): IViolation[] | undefined {
        if (linkedservice && linkedservice.authenticationType === office365AuthTypes.UserAuth && !referencedCredential) {
            return [{
                context: linkedservice,
                message: () => shellStringResources.Error_InvalidCredentialReferenced
            }];
        }
        return undefined;
    }
}
